import React from 'react';
import PropTypes from 'prop-types';

import LocationSelect from 'dpl/common/components/LocationSelect';
import { isMobileUA } from 'dpl/shared/utils';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

const IS_MOBILE_UA = isMobileUA();

export default function LocationDropdown({
  locationOptions,
  handleLocationSelect,
  selectedLocationId,
  closeDropdown,
  isVisible
}) {
  if (IS_MOBILE_UA) {
    return (
      <div className="MobileLocationDropdown h-100 w-100">
        <FixedTooltipPortal
          isVisible={isVisible}
          onCloseClick={closeDropdown}
          wrapperClassName="MobileLocationDropdown__tooltip"
          className="h-100 no-scrollbars pt12 ph5"
          shouldHideCloseButton
        >
          <LocationSelect
            availableLocations={locationOptions}
            onSelect={handleLocationSelect}
            selectedId={selectedLocationId}
            className="overflow-scroll"
            defaultIsOpen
          />
        </FixedTooltipPortal>
      </div>
    );
  }

  return (
    <div className="LocationDropdownWrapper relative z-max">
      <div className="LocationDropdown bg-white w-100 h-100 no-scrollbars br4 ba b--default ph4 pv4">
        <LocationSelect
          availableLocations={locationOptions}
          onSelect={handleLocationSelect}
          selectedId={selectedLocationId}
          closeDropdown={closeDropdown}
          className="overflow-scroll"
          defaultIsOpen
        />
      </div>
    </div>
  );
}

LocationDropdown.propTypes = {
  locationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  handleLocationSelect: PropTypes.func.isRequired,
  closeDropdown: PropTypes.func.isRequired,
  selectedLocationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isVisible: PropTypes.bool.isRequired
};

LocationDropdown.defaultProps = {
  selectedLocationId: null
};
